import firebase from 'firebase/app';
import 'firebase/firestore';

export const createUser = (result, company, token) => {

    firebase.firestore().collection('users').doc(result.user.uid).set({
        firstName: result.additionalUserInfo.profile.given_name,
        lastName: result.additionalUserInfo.profile.family_name,
        company: company,
        email: result.additionalUserInfo.profile.email,
        token: token,
    })
}